import React from "react"

export const Quotes = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="77.697"
    height="76.086"
    viewBox="0 0 77.697 76.086"
    className="fr-testimonial__quote-icon"
  >
    <path
      id="quotemark"
      d="M27.626,1.33a7.41,7.41,0,0,1,6.022,3.231,6.832,6.832,0,0,1,.734,7.344Q29.977,22.188,29.1,29.238A52.124,52.124,0,0,0,28.8,41.429a76.245,76.245,0,0,0,1.763,9.841,43.686,43.686,0,0,1,1.175,10.576q0,7.05-4.407,11.31a15.035,15.035,0,0,1-10.869,4.26A13.663,13.663,0,0,1,4.713,71.1Q.306,64.784.306,53.914A52.441,52.441,0,0,1,3.1,38.345,130.348,130.348,0,0,1,10,21.012a67.24,67.24,0,0,1,8.813-14.1Q23.514,1.33,27.626,1.33Zm42.89,0a7.41,7.41,0,0,1,6.022,3.231,6.832,6.832,0,0,1,.734,7.344q-4.407,10.282-5.288,17.332a52.123,52.123,0,0,0-.294,12.191,76.246,76.246,0,0,0,1.763,9.841,43.686,43.686,0,0,1,1.175,10.576q0,7.05-4.407,11.31a15.035,15.035,0,0,1-10.869,4.26A13.663,13.663,0,0,1,47.6,71.1Q43.2,64.784,43.2,53.914a52.441,52.441,0,0,1,2.791-15.57,130.349,130.349,0,0,1,6.9-17.332A67.24,67.24,0,0,1,61.7,6.912Q66.4,1.33,70.517,1.33Z"
      transform="translate(-0.306 -1.33)"
      fill="#fff"
    />
  </svg>
)
